import { takeLatest, put, call } from 'redux-saga/effects';
import {
    setLoading,
    setSuccess,
    setStudentList,
    setEnrollList,
    setLoadingEnrollments,
    setLoadingEnrollSingleItem,
    setStudentCount
} from '@store/reducers/studentManagementReducer';
import { resourceService } from '@libs/axios';
import {
    fetchingStudentList,
    updateStudents,
    fetchEnrollList,
    enrollSingleItem
} from '@store/actions/studentManagementActions';
import { toast } from 'react-toastify';
import { ResponseType } from '@store/index';

const API_URL = process.env.REACT_APP_API_URL;

function* fetchStudentListData(action: ReturnType<typeof fetchingStudentList>): Generator<any, void, any> {
    const { search_term, province, district, ward, school, role, is_active, student_role,
        classes, module_id_param, enroll_status, page = 1, page_size = 10, edx_course_id } = action.payload || {};
    yield put(setLoading(true));
    yield put(setStudentCount(0));
    const params: any = {
        search_term,
        province,
        district,
        ward,
        school,
        role,
        student_role,
        classes,
        module_id_param,
        enroll_status,
        page,
        page_size,
    };

    if (school && !classes) {
        params.province = null;
        params.district = null;
        params.ward = null;
    } else if (classes) {
        params.province = null;
        params.district = null;
        params.ward = null;
        params.school = null;
    }

    if (is_active !== null && is_active !== undefined) {
        params.status = is_active ? 1 : 0;
    }

    try {
        const response: ResponseType = yield call(
            resourceService.get,
            API_URL + '/api/users/', {
            params
        }
        );

        if (response?.data) {
            let transformedResults: any[] = [];
            response.data?.results?.forEach((result: any) => {
                const enrollments = result.enrollments;
                const matchedEnrollment = enrollments.find(
                    (enrollment: { course_id: string; }) => enrollment.course_id === edx_course_id
                );
                const newResult = {
                    ...result,
                    classes: classes,
                    module_id: module_id_param,
                    enrollment: matchedEnrollment ? matchedEnrollment : null
                };
                transformedResults.push(newResult);
            });
            yield put(setStudentList(transformedResults));
            yield put(setStudentCount(response.data.count));
            yield put(setLoading(false));
        }
    } catch (e: any) {
        yield put(setLoading(false));
        yield put(setStudentCount(0));
        let error: Error = e;
        console.log(error);
    }
}

function* fetchEnrollListData(action: ReturnType<typeof fetchEnrollList>): Generator<any, void, any> {
    const { course_id, usernames, status, page = 1, page_size = 20 } = (action.payload as any) || {};

    yield put(setLoading(true));
    const params: any = {
        course_id,
        usernames,
        status,
        page,
        page_size
    };

    try {
        const response = yield call(
            resourceService.get,
            API_URL + '/api/enrollment_view/',
            params
        );
        if (response?.data?.results && response.status === 200) {
            yield put(setEnrollList(response.data.results));
            yield put(setLoading(false));
        }
    } catch (e: any) {
        yield put(setLoading(false));
        let error: Error = e;
        console.log(error);
    }
}

function* enrollBatchStudentSaga(action: any): Generator<any, void, any> {
    yield put(setSuccess(false));
    yield put(setLoadingEnrollments(true));
    const { data } = action.payload;
    const payload = {
        ...data,
    };

    try {
        const response: any = yield call(resourceService.post, API_URL + `/api/enroll_batch_endpoint/`, payload);
        if (response.status == 200) {
            toast.success('Hệ thống đang thực hiện đăng ký hàng loạt, hãy tải lại trang để cập nhật trạng thái mới nhất');
            yield put(setSuccess(true));
            yield put(setLoadingEnrollments(false));
        }
    } catch (error) {
        // toast.error('Gửi yêu cầu đăng ký hàng loạt thất bại!');
        console.log(error);
        yield put(setSuccess(false));
        yield put(setLoadingEnrollments(false));
    }
}

function* enrollSingleItemSaga(action: any): Generator<any, void, any> {
    yield put(setSuccess(false));
    yield put(setLoadingEnrollSingleItem(true));
    const { data } = action.payload;
    const payload = {
        ...data,
    };

    try {
        const response = yield call(resourceService.post, API_URL + `/api/enroll_single_endpoint/`, payload);
        if (response.status == 200) {
            // toast.success(`Thực hiện đăng ký thành công cho người dùng`);
            yield put(setSuccess(true));
        } else {
            yield put(setSuccess(false));
        }
    } catch (error) {
        // toast.error(`Thực hiện đăng ký thất bại cho người dùng`);
        console.log(error);
        yield put(setSuccess(false));
    } finally {
        yield put(setLoadingEnrollSingleItem(false));
    }
}

function* studentManagementSaga(): Generator<any, void, any> {
    yield takeLatest(fetchingStudentList, fetchStudentListData);
    yield takeLatest(fetchEnrollList, fetchEnrollListData);
    yield takeLatest(updateStudents as any, enrollBatchStudentSaga);
    yield takeLatest(enrollSingleItem as any, enrollSingleItemSaga);
}

export default studentManagementSaga;
